import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { RichText, useBlockProps } from '@wordpress/block-editor';
export default function save(_ref) {
  let {
    attributes
  } = _ref;
  const {
    autoplay,
    caption,
    loop,
    preload,
    src
  } = attributes;
  return src && createElement("figure", useBlockProps.save(), createElement("audio", {
    controls: "controls",
    src: src,
    autoPlay: autoplay,
    loop: loop,
    preload: preload
  }), !RichText.isEmpty(caption) && createElement(RichText.Content, {
    tagName: "figcaption",
    value: caption
  }));
}
//# sourceMappingURL=save.js.map